import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';
import { UpdateWatchlistDataModel } from '../requests';

type UseUpdateWatchlistConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSettled?: UseMutationConfig<any>['onSettled'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useUpdateWatchlistTitle({
  onSuccess,
  onSettled,
  onReject,
}: UseUpdateWatchlistConfigs = {}) {
  const { execute: updateWatchlistTitle, isPending: isUpdatingWatchlistTitle } =
    useMutation(
      (data: UpdateWatchlistDataModel) => API.updateWatchlistTitle(data),
      {
        onSuccess,
        onSettled,
        onReject,
      }
    );

  return {
    updateWatchlistTitle,
    isUpdatingWatchlistTitle,
  };
}
